/**
 * SplitPromoBanner — 50/50 red/black promotional strip.
 * Maps to the Split Promotional Banner section in index.html.
 * Design tokens: ds-primary (red panel), ds-inverse-surface (dark panel),
 * ds-on-primary (white text), barlow (headlines), inter (body).
 *
 * Content is driven by the PROMO_PANELS constant below.
 * To update copy or link, edit only the constant — not the JSX.
 */
import { Link } from "react-router-dom";
import { ROUTES } from "../constants";

const PROMO_PANELS = [
  {
    bg: "bg-ds-primary",
    hoverBg: "hover:bg-ds-primary-hover",
    textColor: "text-white",
    headline: "FREE SHIPPING",
    body: "On all orders over Rs. 2,000",
    cta: "SHOP NOW →",
    ctaClass: "text-white underline underline-offset-2",
    to: ROUTES.PRODUCT_CATEGORY,
  },
  {
    bg: "bg-ds-inverse-surface",
    hoverBg: "",
    textColor: "text-white",
    headline: "100% GENUINE BRANDS",
    body: "Authentic helmets & gear, every order guaranteed",
    cta: "SEE OUR BRANDS →",
    ctaClass:
      "text-ds-primary underline underline-offset-2 hover:text-ds-primary-hover",
    to: ROUTES.PRODUCT_CATEGORY,
  },
];

const SplitPromoBanner = () => (
  <section className="w-full h-[200px] flex" aria-label="Promotions">
    {PROMO_PANELS.map(
      ({ bg, hoverBg, textColor, headline, body, cta, ctaClass, to }) => (
        <Link
          key={headline}
          to={to}
          className={`flex-1 ${bg} ${hoverBg} flex flex-col justify-center pl-10 md:pl-16 transition-colors duration-200 border-r border-white/10 last:border-r-0`}
          aria-label={headline}
        >
          <h2
            className={`font-barlow font-extrabold text-[36px] md:text-[40px] ${textColor} leading-tight uppercase`}
          >
            {headline}
          </h2>
          <p
            className={`font-inter text-[14px] md:text-[15px] ${textColor} opacity-85 mb-2 mt-1`}
          >
            {body}
          </p>
          <span className={`font-inter text-[13px] font-semibold ${ctaClass}`}>
            {cta}
          </span>
        </Link>
      ),
    )}
  </section>
);

export default SplitPromoBanner;
